/* eslint-disable bam/no-react-unbound */
import $ from 'jquery';
import { modalCloseClass } from '../_helpers/constants';

export default class Modal {
  constructor() {
    this.modalClose = null;
  }

  init() {
    this.modalClose = $(modalCloseClass);
    this.modalClose.on('click', async function () {
      $('.modal').hide();
    });
  }
}
